import { Droplet, Fuel, Volume2 } from "lucide-react";

// Compact EU tyre label row (additive — used on product cards).
const EuLabelRow = ({ tyre, testid }) => {
  if (!tyre) return null;
  return (
    <div className="flex items-center gap-2 mt-2 text-[11px]" data-testid={testid || "eu-label-row"}>
      <Chip Icon={Fuel} value={tyre.fuel_efficiency} title={`Fuel efficiency: ${tyre.fuel_efficiency}`} />
      <Chip Icon={Droplet} value={tyre.wet_grip} title={`Wet grip: ${tyre.wet_grip}`} />
      <Chip Icon={Volume2} value={tyre.noise_level} title={`Noise: ${tyre.noise_level}`} />
    </div>
  );
};

const Chip = ({ Icon, value, title }) => (
  <span
    className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-semibold"
    style={{
      background: "var(--bg-secondary)",
      color: "var(--text-heading)",
      border: "1px solid var(--border-color)",
    }}
    title={title}
  >
    <Icon size={11} color="var(--primary-red)" strokeWidth={2} />
    {value}
  </span>
);

export default EuLabelRow;
